<template>
  <div class="ProductFiltering" dir="rtl">
    <span class="pointer text-icon toggle-btn" data-bs-toggle="offcanvas" data-bs-target="#filtering" aria-controls="filtering"><i class="fa-solid fa-filter"></i> فیلتر محصولات </span>
    <div class="offcanvas offcanvas-end cart-offcanvas" tabindex="-1" id="filtering" aria-labelledby="filter-header">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="filter-header">فیلترها</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="بستن"></button>
      </div>
      <div class="offcanvas-body" id="filter-body">
        <button class="btn btn-secondary mb-3" v-if="Object.keys($route.query).length !== 0" @click="$router.push($route.path)">حذف فیلتر‌ها</button>
        <GenderF class="mb-3" />
        <PriceF class="mb-3" />
        <CheckboxListF name="brands" text="برند‌ها" :objects="brands" class="mb-3" search/>
        <CheckboxListF name="c" text="دسته‌بندی‌ها" :objects="categories" class="mb-3" search v-if="categories"/>
        <CheckboxListF name="age" text="رده سنی" :objects="[{'name':'کودک و نوجوان','id':1},{'name':'جوان','id':2},{'name':'بزرگسال','id':3}]" class="mb-3" />
        <BoolF class="mb-3" name="available" text="فقط کالاهای موجود" />
        <BoolF class="mb-3" name="haveOff" text="فقط تخفیف‌دارها" />
        <BoolF class="mb-3" name="orginal" text="فقط اورجینال ها" />
      </div>
    </div>
  </div>
</template>

<script>
import BoolF from '@/components/filters/BoolF.vue'
import GenderF from '@/components/filters/GenderF.vue'
import CheckboxListF from '@/components/filters/CheckboxListF.vue'
import PriceF from '@/components/filters/PriceF.vue'

export default {
  name: 'ProductFiltering',
  components: {
    BoolF,
    GenderF,
    CheckboxListF,
    PriceF
  },
  data () {
    return {}
  },
  props: {
    brands: Array,
    categories: Array
  },
  methods: {}
}
</script>

<style scoped>
.text-icon{
  color: #707071;
}
.toggle-btn{
  border: solid 1px #18bbce;
  background-color: #18bbce;
  color: black;
  padding: 6px 10px;
  border-radius: 24px;
  transition: 0.4s;
}
.toggle-btn:hover{
  border: solid 1px #18bbce;
  background-color: white;
  color: black;
  padding: 4px 8px;
  border-radius: 24px;
}
</style>
